import type { OrganizationBillingInfoType } from '@kanbu/schema';
import { Trans } from '@lingui/react/macro';
import { memo } from 'react';

export type OrganizationBillingInfoProps = {
  billingInfo: OrganizationBillingInfoType;
};
export const OrganizationBillingInfo = memo(
  ({ billingInfo }: OrganizationBillingInfoProps) => (
    <div className='space-y-2 text-sm'>
      {billingInfo.isCompany && (
        <div className='space-y-1'>
          <div className='font-semibold'>{billingInfo.companyName}</div>
          <div>
            <Trans>IČO:</Trans> {billingInfo.registrationNumber}
          </div>
          <div>
            <Trans>DIČ:</Trans> {billingInfo.vatId}
          </div>
        </div>
      )}
      <div className='space-y-1'>
        {billingInfo.addressLine1 && <div>{billingInfo.addressLine1}</div>}
        {billingInfo.addressLine2 && <div>{billingInfo.addressLine2}</div>}
        <div>
          {billingInfo.city && <span>{billingInfo.city}</span>}
          {billingInfo.city && billingInfo.postalCode && <span>, </span>}
          {billingInfo.postalCode && <span>{billingInfo.postalCode}</span>}
        </div>
      </div>
      {billingInfo.billingEmail && (
        <div className='space-y-1'>
          <p className='font-semibold'>
            <Trans>Billing Email:</Trans>
          </p>
          <p>{billingInfo.billingEmail}</p>
        </div>
      )}
      {billingInfo.invoiceCcEmail && (
        <div className='space-y-1'>
          <p className='font-semibold'>
            <Trans>Invoice CC Email:</Trans>
          </p>
          <p>{billingInfo.invoiceCcEmail}</p>
        </div>
      )}
    </div>
  ),
);
